import css from './assets/css/desktop-promo.module.css';
import logo from './assets/logo_converted.webp';
import qrCode from './assets/qr_converted.webp';

const DesktopPromo = () => {
    return (
        <div className={css.desktopPromoContainer}>
            <div className={css.desktopPromoHeader}>
                <img src={logo} alt="Logo" />
            </div>
            <div className={css.desktopPromoCenteredBox}>
                <div className={css.desktopPromoQRCode} style={{ backgroundImage: `url(${qrCode})` }}></div>
                <span className={css.desktopPromoTitle}>SCAN QR-CODE TO ACCESS</span>
                <span className={css.desktopPromoTitle}>THE PROJECT</span>
            </div>
        </div>
    );
}

export default DesktopPromo;
